"use strict";

require("core-js/modules/es.array.includes");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.string.includes");

var rejectL = require("../Lazy/rejectL.js");

var curry = require("./curry.js");

var object = require("./object.js");

var entriesL = require("../Lazy/entriesL.js");

module.exports = curry(function omit(ks, obj) {
  return object(rejectL(([k]) => ks.includes(k), entriesL(obj)));
});